module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noItemsMessage":"No events to show."},"fi":{"noItemsMessage":"Tapahtumia ei löytynyt."}}')
  delete Component.options._Ctor
}
